export default __webpack_public_path__ + "static/media/quote.4ca46609.svg";